export const translations = {
  es: {
    home: "Inicio",
    about: "Sobre mí",
    skills: "Habilidades",
    work: "Trabajos",
    contact: "Contacto",
    switch: "Cambiar a Inglés",
    linkedin: "LinkedIn",
    github: "Github",
    email: "Email",
    cv: "CV",
    // Home
    home_greeting: "Hola, mi nombre es",
    home_role: "Soy Full Stack Developer",
    home_desc: "Soy Licenciado en Relaciones Internacionales, pero mi pasión por el aprendizaje me llevó a iniciar mi camino como developer en 2022. Realicè el curso de Full Stack Developer en Coderhouse, donde aprendí tanto Frontend con HTML,CSS,JS y React, como Backend con Node. Continuè apreniendo por mi cuenta programación backend con C# y .NET.  Actualmente trabajo como Frontend Developer en Digital Pathology Lab (donde aprendí Next.js), y como Client Services Representative en Elevate Teams para una agencia de California.",
    home_button: "Mirá mis trabajos",
    // About
    about_title: "Sobre mí",
    about_hi: "Hola! Soy Tomás, gracias por visitar mi página.",
    about_desc: "Aunque soy Licenciado en Relaciones Internacionales, también me fascina la tecnología y decidí dar un giro y dedicar mi tiempo para en un futuro ser profesional en programación. Creo que en la actualidad la tecnología es indispensable para nuestras vidas, por lo que decidí empezar a aprender cómo trabajar con ella.",
    // Skills
    skills_title: "Habilidades",
    skills_desc: "Actualmente tengo conocimientos en estas tecnologías:",
    // Contact
    contact_email: "Enviame un email",
    contact_whatsapp: "Contáctame por WhatsApp",
    contact_name: "Nombre",
    contact_message: "Mensaje",
    contact_send: "Enviar",
    // Work
    work_title: "Mis trabajos",
    work_desc: "Estos son algunos de los proyectos que realicé. TdSocial es un pequeño proyecto de una red social estilo X, hecho con Next.js, utilizando Prisma. Ricanova -aún en construcción- es un proyecto para un cliente español. Es una empresa de coches y artículos de bebé; el proyecto se encuentra en desarrollo con React.js y Node.js.  Ruth Pastelería es mi segundo proyecto màs reciente para una clienta, ya entregado, por lo que el código es privado. Es un ecommerce serverless (con Vercel functions) hecho con ReactJS que cuenta con un panel de administrador para manejar los productos. Aguamerica fue mi primer proyecto, el cual hice para el curso de Desarrollo Web.  TOM'S Store fue el segundo; es un ecommerce hecho con ReactJS. Además, en este momento estoy trabajando en nuevos proyectos con Next.js para adquirir experiencia.",
    work_demo: "Demo",
    work_code: "Código",
    work_privateCode: "Código (privado)",
  },
  en: {
    home: "Home",
    about: "About me",
    skills: "Skills",
    work: "Work",
    contact: "Contact",
    switch: "Switch to Spanish",
    linkedin: "LinkedIn",
    github: "Github",
    email: "Email",
    cv: "CV",
    // Home
    home_greeting: "Hi, my name is",
    home_role: "I am a Full Stack Developer",
    home_desc: "I have a degree in International Relations, but my passion for learning led me to start my journey as a developer in 2022.  I completed the Full Stack Developer course at Coderhouse, where I learned both Frontend development with HTML, CSS, JS, and React, and Backend development with Node.   I continued learning Backend programming on my own with C# and .NET. Currently, I work as a Frontend Developer at Digital Pathology Lab (where I learned Next.js) and as a Client Services Representative at Elevate Teams for an agency in California.",
    home_button: "Take a look at my work",
    // About
    about_title: "About me",
    about_hi: "Hi! My name is Tomas, thank you for visiting my webpage",
    about_desc: "Although I have a degree in International Relations, I am also fascinated by technology and decided to make a shift, dedicating my time to becoming a professional in programming in the future. I believe that technology is essential in our lives today, which is why I decided to start learning how to work with it.",
    // Skills
    skills_title: "Skills",
    skills_desc: "I have knowledge in the following technologies:",
    // Contact
    contact_email: "Send me an email",
    contact_whatsapp: "Contact me via Whatsapp",
    contact_name: "Name",
    contact_message: "Message",
    contact_send: "Send",
    // Work
    work_title: "My work",
    work_desc: "These are some of the projects I have worked on. TdSocial is a small project for a social network similar to X, made with Next.js, using Prisma. Ricanova -still under construction- is a project for a Spanish client. It is a company that sells cars and baby items; the project is being developed with React.js and Node.js. Ruth Pastelería is my second most recent project for a client, already delivered, which is why the code is private. It is a serverless ecommerce built with ReactJS that includes an admin panel to manage products. Aguamerica was my first project, which I did for the Web Development course. TOM'S Store was the second; it is an ecommerce made with ReactJS. Additionally, I am currently working on new projects with Next.js to gain experience.",
    work_demo: "Demo",
    work_code: "Code",
    work_privateCode: "Private code",
  },
};